import {SetStateAction} from 'react';
import Axios, {AxiosError} from 'axios';

export class AxiosErrorHandler {
  static handle(errorSet: (value: SetStateAction<{ [p: string]: string }>) => void) {
    return (error: Error | AxiosError) => {
      if (Axios.isAxiosError(error)) {
        errorSet(error.response?.data?.errors ?? {});
      } else {
        console.error(error);
      }
    };
  }
}
